import axios from "axios"
import { getBaseRestApiUrl } from "../../utils/getApiUrl"

export class ApiManager {
  static login = (email: string, password: string) => {
    return axios.post(getBaseRestApiUrl() + "/login", { email, password })
  }
}
